import { useState, type ComponentPropsWithoutRef } from 'react';

/** type 은 내부에서 토글하므로 밖에서 지정할 수 없다. */
type PasswordInputProps = Omit<ComponentPropsWithoutRef<'input'>, 'type'>;

/**
 * 오른쪽 끝에 보기/숨기기 토글이 달린 비밀번호 입력창.
 *
 * <p>`.input` 을 그대로 쓰므로 기존 `<input className="input" type="password">` 를
 * 그대로 대체할 수 있다. id / required / minLength / autoComplete 등 표준 속성은
 * 모두 그대로 전달된다.
 */
export function PasswordInput({ className = 'input', ...rest }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-field">
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        className={`${className} password-field__input`}
      />
      <button
        type="button"
        className="password-field__toggle"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? '비밀번호 숨기기' : '비밀번호 보기'}
        aria-pressed={visible}
        title={visible ? '숨기기' : '보기'}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
}

function EyeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}
